// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__qoP5j","toggle":"styles_toggle__38i9R","preview":"styles_preview__1ZvfV"};